import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
    Button,
    FormGroup,
    Input,
    Modal,
    ModalBody, ModalFooter,
    ModalHeader
} from 'reactstrap';
import api from '../../../../../services/api-configuration';
import { capitalizeWords } from '../../../../../utils/CapitalizeWords';

function IslemlerEklePopup({ isOpen, toggle, refreshData, groupageNo }) {

    const [chassisNo, setChassisNo] = useState("");
    const [buttonStatus, setButtonStatus] = useState("idle");
    const isValid = chassisNo.length === 17

    // Modal açıldığında state'leri sıfırla
    useEffect(() => {
        if (isOpen) {
            setChassisNo("");
            setButtonStatus("idle");
        }
    }, [isOpen]);

    const handleChassiNoChange = (e) => {
        const rawValue = e.target.value

        const cleanValue = rawValue.replace(/[^a-zA-Z0-9]/g, '');

        setChassisNo(cleanValue.toUpperCase())


    }
    const handleClose = () => {
        if (buttonStatus === "loading") return;
        toggle();
        setChassisNo("");
        setButtonStatus("idle");
    };

    const handleSave = async () => {
        setButtonStatus("loading")
        try {
            const response = await api.post("/addVehicleToGroupage", {
                chassis_no: chassisNo.replaceAll(" ", ""),
                groupage_no: groupageNo.replaceAll(" ", "")
            })
            toast.success(response.data.message)
            setButtonStatus("success");
            await refreshData();
            // Başarılı işlem sonrası modal'ı kapat
            setTimeout(() => {
                toggle();
            }, 1000);
        } catch (error) {
            console.error(error)
            let message = error.response?.data?.error || "Bir Hata Oluştu"
            toast.error(capitalizeWords(message))
            setButtonStatus("idle")
        }
    }

    return (
        <Modal
            isOpen={isOpen}
            toggle={handleClose}
            backdrop="static"
            style={{
                height: "345px",
                maxHeight: "400px",
                maxWidth: "700px",
                width: "90%",
                margin: "1.75rem auto"
            }}>
            <ModalHeader
                toggle={handleClose}
            >Grupaja Şase Ekleme</ModalHeader>
            <ModalBody>
                <FormGroup>
                    <div style={{ position: 'relative' }}>
                        <Input
                            type="text"
                            placeholder="Şase numarasını giriniz..."
                            value={chassisNo}
                            onChange={handleChassiNoChange}
                            maxLength={17}
                            autoFocus
                            style={{
                                fontSize: '18px',
                                padding: '12px',
                                borderColor: isValid ? '#28a745' : chassisNo.length > 0 ? '#dc3545' : '#ccc',
                                borderWidth: '2px',
                            }}
                        />
                        <small style={{
                            position: 'absolute',
                            right: '12px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            color: '#6c757d',
                            fontSize: '12px'
                        }}>
                            {chassisNo.length}/17
                        </small>
                    </div>
                    {chassisNo.length > 0 && !isValid && (
                        <p style={{ color: 'red', fontSize: '0.9rem', marginTop: '8px' }}>
                            Şase numarası tam olarak 17 karakter olmalıdır.
                        </p>
                    )}
                </FormGroup>
            </ModalBody>
            <ModalFooter>

                <Button
                    color="primary"
                    disabled={
                        chassisNo.trim().length !== 17 ||
                        buttonStatus === "loading" ||
                        buttonStatus === "success"
                    }
                    onClick={handleSave}
                >
                    {{
                        idle: "Ekle",
                        loading: "Ekleniyor...",
                        success: "Eklendi"
                    }[buttonStatus]}
                </Button>
            </ModalFooter>
        </Modal>
    );
}

export default IslemlerEklePopup;